import { numberFormat } from '@/helpers/numbers'
import type { CanteenCartItem } from './types'

type ItemWithPrice = { price: string | number }
type OptionWithPrice = { price?: string | number }

export const sumItemOptionsCost = (options: OptionWithPrice[] = []) =>
  options.reduce((total, { price }) => total + Number.parseFloat(price?.toString() ?? '0'), 0)

export const calcItemTotalCost = (
  price: number | string = 0,
  optionsCost: number | string = 0,
  qty: number | string = 0,
) =>
  (Number.parseFloat(price.toString()) + Number.parseFloat(optionsCost.toString())) *
  Number.parseInt(qty.toString(), 10)

type MinimalCartItem = {
  item: ItemWithPrice
  options: OptionWithPrice[]
  qty: number | string
}

export const calculateCartItemTotal = (cartItem: MinimalCartItem) =>
  Number.parseFloat(
    numberFormat(
      calcItemTotalCost(cartItem.item.price, sumItemOptionsCost(cartItem.options), cartItem.qty),
      2,
      false,
    ),
  )

export const calculateCartTotal = (cartItems: CanteenCartItem[] = []) => {
  const cartTotal = cartItems.reduce(
    (total, cartItem) => total + calculateCartItemTotal(cartItem),
    0,
  )

  return Number.parseFloat(numberFormat(cartTotal, 2, false))
}
